module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-1-fdc0af7eec10ca349b129d396f7d4ae8.png";